export default __webpack_public_path__ + "static/flow-a1177ed9adabd57faeaafa6379077bf2.png";